module.exports = __webpack_public_path__ + "static/media/Valk4.cde5dac5.png";